import React, { useState } from 'react';
// import { 
//   AdminWordSelection
// } from '@/types/wordTraining';
// import { FingerType } from '@/types';
// import WordSelectionPanel from './WordSelectionPanel';
import CourseConfigurationManager from './CourseConfigurationManager';
import CSVUploadUtility from './CSVUploadUtility';
import ConfigurationTab from './ConfigurationTab';
import CourseCSVUpload from './CourseCSVUpload';

/**
 * Admin Dashboard for Course Training Word Configuration
 * 
 * Simplified admin panel with basic functionality for managing
 * word training data and course configurations.
 */

interface AdminDashboardProps {
  onClose?: () => void;
}

type AdminTab = 'configuration' | 'upload' | 'management' | 'course-upload';

const AdminDashboard: React.FC<AdminDashboardProps> = ({ onClose }) => {
  const [activeTab, setActiveTab] = useState<AdminTab>('configuration');
  // const [selectedDay, setSelectedDay] = useState(1);
  // const [selectedRound, setSelectedRound] = useState(1);
  // const [selectedFingers, setSelectedFingers] = useState<FingerType[]>(['leftPinky', 'rightPinky']);
  // const [wordSelection, setWordSelection] = useState<AdminWordSelection>({
  //   mode: 'random',
  //   random: {
  //     wordLengths: [3, 4, 5],
  //     includePhrases: true,
  //     quantity: 20
  //   }
  // });
  // const [availableWordData, setAvailableWordData] = useState<WordTrainingData | null>(null);
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleTabChange = (tab: AdminTab) => {
    setActiveTab(tab);
    setError(null);
    setSuccess(null);
  };

  // const loadAvailableWordData = async () => {
  //   setLoading(true);
  //   setError(null);
  //   
  //   try {
  //     const hand = getHandFromFingersForWordTraining(selectedFingers);
  //     const wordData = await getWordsByFingerCombination(selectedFingers, hand);
  //     setAvailableWordData(wordData);
  //     
  //     if (!wordData) {
  //       setError(`No word training data found for selected finger combination: ${mapFingersToKey(selectedFingers)}_${hand}`);
  //     }
  //   } catch (error) {
  //     console.error('❌ Error loading word data:', error);
  //     setError('Failed to load word training data');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'upload':
        return (
          <div className="tab-content">
            <CSVUploadUtility
              onUploadComplete={(result) => {
                setSuccess(`CSV uploaded successfully! ${result.successful} combinations processed.`);
              }}
              onUploadError={(error) => {
                setError(`CSV upload failed: ${error}`);
              }}
            />
          </div>
        );

      case 'configuration':
        return (
          <div className="tab-content">
            <ConfigurationTab
              onConfigurationSaved={(level, day, round) => {
                setSuccess(`Configuration saved for Level ${level}, Day ${day}, Round ${round}`);
              }}
              onError={(error) => {
                setError(error);
              }}
              onSuccess={(message) => {
                setSuccess(message);
              }}
            />
          </div>
        );

      case 'management':
        return (
          <div className="tab-content">
            <CourseConfigurationManager
              onConfigurationChange={(config) => {
                if (config) {
                  // setSelectedDay(config.dayNumber);
                  // setSelectedRound(config.roundNumber);
                  // setWordSelection(config.wordSelection);
                  setActiveTab('configuration');
                }
              }}
            />
          </div>
        );

      case 'course-upload':
        return (
          <div className="tab-content">
            <CourseCSVUpload
              onUploadComplete={(result) => {
                setSuccess(`Course CSV uploaded successfully! ${result.successful} configurations processed.`);
              }}
              onError={(error) => {
                setError(`Course CSV upload failed: ${error}`);
              }}
            />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>⚙️ KeyboardHero Admin Panel</h1>
        {onClose && (
          <button className="close-btn" onClick={onClose}>
            ✕
          </button>
        )}
      </div>

      {/* Tab Navigation */}
      <div className="tab-navigation">
        <button
          className={`tab-btn ${activeTab === 'upload' ? 'active' : ''}`}
          onClick={() => handleTabChange('upload')}
        >
          📤 CSV Upload
        </button>
        <button
          className={`tab-btn ${activeTab === 'course-upload' ? 'active' : ''}`}
          onClick={() => handleTabChange('course-upload')}
        >
          📚 Course Upload
        </button>
        <button
          className={`tab-btn ${activeTab === 'configuration' ? 'active' : ''}`}
          onClick={() => handleTabChange('configuration')}
        >
          📊 Configuration
        </button>
        <button
          className={`tab-btn ${activeTab === 'management' ? 'active' : ''}`}
          onClick={() => handleTabChange('management')}
        >
          ⚙️ Management
        </button>
      </div>

      {/* Status Messages */}
      {/* {loading && (
        <div className="status-message loading">
          <div className="spinner"></div>
          <span>Loading...</span>
        </div>
      )} */}

      {error && (
        <div className="status-message error">
          <span className="icon">⚠️</span>
          <span>{error}</span>
          <button className="close-status" onClick={() => setError(null)}>✕</button>
        </div>
      )}

      {success && (
        <div className="status-message success">
          <span className="icon">✅</span>
          <span>{success}</span>
          <button className="close-status" onClick={() => setSuccess(null)}>✕</button>
        </div>
      )}

      {/* Tab Content */}
      <div className="tab-container">
        {renderTabContent()}
      </div>

      <style>{`
        .admin-dashboard {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
          background: rgba(17, 24, 39, 0.95);
          border-radius: 12px;
          color: white;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
          max-height: 90vh;
          overflow-y: auto;
        }

        .admin-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
          padding-bottom: 16px;
          border-bottom: 2px solid rgba(59, 130, 246, 0.3);
        }

        .admin-header h1 {
          margin: 0;
          font-size: 1.8rem;
          font-weight: 700;
          background: linear-gradient(45deg, #3b82f6, #22c55e);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .close-btn {
          width: 32px;
          height: 32px;
          border: none;
          background: rgba(239, 68, 68, 0.2);
          color: #ef4444;
          border-radius: 50%;
          cursor: pointer;
          font-size: 1.2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }

        .close-btn:hover {
          background: rgba(239, 68, 68, 0.3);
          transform: scale(1.1);
        }

        .tab-navigation {
          display: flex;
          gap: 4px;
          margin-bottom: 24px;
          background: rgba(31, 41, 55, 0.5);
          padding: 4px;
          border-radius: 8px;
        }

        .tab-btn {
          flex: 1;
          padding: 12px 16px;
          border: none;
          background: transparent;
          color: #9ca3af;
          border-radius: 6px;
          cursor: pointer;
          font-size: 0.9rem;
          font-weight: 600;
          transition: all 0.2s ease;
        }

        .tab-btn:hover {
          background: rgba(59, 130, 246, 0.2);
          color: #e5e7eb;
        }

        .tab-btn.active {
          background: rgba(59, 130, 246, 0.8);
          color: white;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }

        .status-message {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 16px;
          border-radius: 6px;
          margin-bottom: 16px;
          font-size: 0.9rem;
        }

        .status-message.loading {
          background: rgba(59, 130, 246, 0.1);
          border: 1px solid rgba(59, 130, 246, 0.3);
          color: #60a5fa;
        }

        .status-message.error {
          background: rgba(239, 68, 68, 0.1);
          border: 1px solid rgba(239, 68, 68, 0.3);
          color: #fca5a5;
        }

        .status-message.success {
          background: rgba(34, 197, 94, 0.1);
          border: 1px solid rgba(34, 197, 94, 0.3);
          color: #86efac;
        }

        .close-status {
          margin-left: auto;
          background: none;
          border: none;
          color: inherit;
          cursor: pointer;
          font-size: 1.2rem;
          opacity: 0.7;
          transition: opacity 0.2s ease;
        }

        .close-status:hover {
          opacity: 1;
        }

        .spinner {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(59, 130, 246, 0.3);
          border-top-color: #3b82f6;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .tab-container {
          background: rgba(31, 41, 55, 0.3);
          border-radius: 8px;
          padding: 24px;
        }

        .tab-content {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }



        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .admin-dashboard {
            padding: 16px;
            margin: 10px;
          }

          .tab-navigation {
            flex-direction: column;
          }

          .admin-header h1 {
            font-size: 1.4rem;
          }
        }
      `}</style>
    </div>
  );
};

export default AdminDashboard;
